import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS,FETCH_LOADING,FETCH_END } from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  initialURL: '/',
  error: '',
  message: '',
  loading: false,
  stableLoading:false,
  loadingMessage:""
};

export default (state = INIT_STATE, action) => {
  let loadingMessage = typeof action.flag ==="string"?action.flag:"";
  switch (action.type) {
    case FETCH_LOADING: {
      return { ...state, stableLoading: action.flag===false?false:true,loadingMessage };
    }
    case FETCH_START: {
      return { ...state, error: '', message: '', loading: true,loadingMessage };
    }
    case FETCH_END: {
      return { ...state, error: '', loading: false, message: '',loadingMessage:'' };
    }
    case FETCH_SUCCESS: {
      return { ...state, error: '', loading: false, message: action.payload,loadingMessage:'',messageTicks:action.messageTicks };
    }
    case FETCH_ERROR: {
      return { ...state, loading: false, message: '', error: action.payload,loadingMessage:'',messageTicks:action.messageTicks };
    }
    default:
      return state;
  }
};
